import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Utils from '../../common/utils/utils';
import { SystemMessagesService } from '../../common/services/system-messages.service';
@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'go-footer',
    templateUrl: 'footer.component.html',
    // eslint-disable-next-line @angular-eslint/prefer-standalone
    standalone: false
})

export class FooterComponent implements OnInit { // Added OnInit for clarity, though not strictly required for compilation here
    paperWorkMsg: string;

    constructor(
        private systemMessagesService: SystemMessagesService,
        private translate: TranslateService) {

    }

    ngOnInit() {

        //if language selection is changed, fetch relevant system messages data.
        this.systemMessagesService.sysMessagesUpdatedSubj.subscribe(res => {
            this.systemMessagesService.getSysMessages().subscribe((res: any) => {
                const data = res[this.translate.currentLang];

                if (data ) {
                    this.paperWorkMsg = data['login.main'].PRA;
                    //console.log("paperwork message retrieved: " + this.paperWorkMsg);
                }
            });
        });
    }

    getAppStoreBadgeSrc(): string {
      const lang = this.translate.currentLang;
      switch (lang) {
        case 'es':
          return 'assets/images/badges/Download_on_the_App_Store_Badge_ES_RGB_blk_100217.svg';
        case 'fr':
          return 'assets/images/badges/Download_on_the_App_Store_Badge_FR_RGB_blk_100517.svg';
        default:
          return 'assets/images/badges/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
        // return 'assets/images/badges/App_Store_Badge_US_UK_transparent.svg';
      }
    }

    getGooglePlayBadgeSrc(): string {
      const lang = this.translate.currentLang;
      switch (lang) {
        case 'es':
          return 'assets/images/badges/GetItOnGooglePlay_Badge_Web_color_Spanish.svg';
        case 'fr':
          return 'assets/images/badges/GetItOnGooglePlay_Badge_Web_color_French.svg';
        default:
          return 'assets/images/badges/GetItOnGooglePlay_Badge_Web_color_English.svg';
        // return 'assets/images/badges/GetItOnGooglePlay_Badge_Web_transparent_English.svg';
      }
    }

    sc() {
        Utils.scrollUp();
    }

}

